import {
  IconAmex,
  IconKlarna,
  IconMasterCard,
  IconSvea,
  IconSwish,
  IconVisa,
  IconVipps
} from 'components/Shared/Icon';
import { PaymentType } from 'models/PaymentType';
import styles from './paymentIcons.scss';

const paymentIcons = new Map([
  [PaymentType.Amex, <IconAmex key="amex" size="xl" />],
  [PaymentType.Klarna, <IconKlarna key="klarna" size="xl" />],
  [PaymentType.MasterCard, <IconMasterCard key="masterCard" size="xl" />],
  [PaymentType.Svea, <IconSvea key="svea" size="xl" />],
  [PaymentType.Swish, <IconSwish key="swish" className={styles.swish} />],
  [PaymentType.Visa, <IconVisa key="visa" size="xl" />],
  [PaymentType.Vipps, <IconVipps key="vipps" size="large" />],
  [PaymentType.Unknown, null]
]);

export default (paymentMethod: PaymentType) => paymentIcons.get(paymentMethod);
